import { FC } from 'react';
import Hero from 'src/safety/components/Hero';
import RenterResources from 'src/safety/components/RenterResources';
import RenterFAQ from 'src/safety/components/RenterFAQ';
import OwnerAndCaptainGuides from 'src/safety/components/OwnerAndCaptainGuides';
import OwnerResources from 'src/safety/components/OwnerResources';
import OwnerFAQ from 'src/safety/components/OwnerFAQ';
import Footer from 'src/safety/components/Footer';

const SafetyRoot: FC = () => (
  <main>
    <Hero />
    <RenterResources />
    <RenterFAQ />
    <OwnerAndCaptainGuides />
    <OwnerResources />
    <OwnerFAQ />
    <Footer />
  </main>
);

export default SafetyRoot;
